var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "row", attrs: { id: "app" } }, [
      _c(
        "div",
        { staticClass: "col-xl-8 col-lg-12 col-md-6 col-sm-12 col-12" },
        [
          _c("div", { staticClass: "panel panel-info" }, [
            _c("div", { staticClass: "panel-heading" }, [
              _c("span", { staticClass: "badge" }, [
                _vm._v(_vm._s(Object.keys(_vm.members).length))
              ]),
              _vm._v(" Members\n        ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "panel-body" }, [
              _vm.joined
                ? _c("div", [
                    _c("em", [
                      _c("span", {
                        domProps: { textContent: _vm._s(_vm.status) }
                      })
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { ref: "chatWrapper", staticClass: "chat-wrapper" },
                      [
                        _c(
                          "ul",
                          { staticClass: "chat" },
                          _vm._l(_vm.messages, function(message) {
                            return _c("li", { staticClass: "left clearfix" }, [
                              _c("div", { staticClass: "chat-body clearfix" }, [
                                _c("div", { staticClass: "header" }, [
                                  _c(
                                    "strong",
                                    { staticClass: "primary-font" },
                                    [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(message.username) +
                                          "\n                      "
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(message.message) +
                                      "\n                    "
                                  )
                                ])
                              ])
                            ])
                          }),
                          0
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "panel-footer" }, [
                      _c("div", { staticClass: "input-group" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.newMessage,
                              expression: "newMessage"
                            }
                          ],
                          ref: "messageInputField",
                          staticClass: "form-control input-sm",
                          attrs: {
                            id: "btn-input",
                            type: "text",
                            name: "message",
                            placeholder: "Type your message here..."
                          },
                          domProps: { value: _vm.newMessage },
                          on: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.sendMessage($event)
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.newMessage = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "input-group-btn" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary btn-sm",
                              attrs: { id: "btn-chat" },
                              on: { click: _vm.sendMessage }
                            },
                            [_vm._v("Send")]
                          )
                        ])
                      ]),
                      _c("br"),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "input-group" },
                        [
                          _vm._v(
                            "\n                Members : \n                "
                          ),
                          _vm._l(_vm.members, function(member) {
                            return _c("span", [
                              _c("b", [_vm._v(_vm._s(member))]),
                              _vm._v(", ")
                            ])
                          })
                        ],
                        2
                      )
                    ])
                  ])
                : _c("div", [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", [_vm._v("Room Name")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.room,
                            expression: "room"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text", placeholder: "chat room name" },
                        domProps: { value: _vm.room },
                        on: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.joinChat($event)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.room = $event.target.value
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", [_vm._v("Username")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          { name: "focus", rawName: "v-focus" },
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.username,
                            expression: "username"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          placeholder: "enter your username to join chat"
                        },
                        domProps: { value: _vm.username },
                        on: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.joinChat($event)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.username = $event.target.value
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        on: { click: _vm.joinChat }
                      },
                      [_vm._v("JOIN")]
                    )
                  ])
            ])
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }